import { Grid } from "@mui/material";
import DataHubTable from "./components/DataHubTable";
import { useDataHubBuildingMeters } from "./hooks";
import { string, func, array, object } from "prop-types";
import React from "react";
import type { Dispatch, SetStateAction } from "react";

interface DatahubMetersProps {
  view: string;
  setView: Dispatch<SetStateAction<string>>;
  meterIdList: string[];
  setSelectedItem?: (item: any) => void;
  selectedItem?: any;
  gettext?: (key: string) => string;
}

const DatahubMeters = (props: DatahubMetersProps) => {
  const { view, setView, meterIdList, setSelectedItem, selectedItem, gettext } =
    props;
  const { metersList, loading } = useDataHubBuildingMeters(meterIdList);

  return (
    <Grid>
      <DataHubTable
        title={view}
        setView={setView}
        view={view}
        rows={metersList}
        setSelectedItem={setSelectedItem}
        selectedItem={selectedItem}
        gettext={gettext}
        loading={loading}
      />
    </Grid>
  );
};
export default DatahubMeters;

DatahubMeters.propTypes = {
  view: string.isRequired,
  setView: func.isRequired,
  meterIdList: array.isRequired,
  setSelectedItem: func,
  selectedItem: object,
  gettext: func,
};
